import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function CustomCursor() {
    const [variant, setVariant] = useState("default");
    const [enabled, setEnabled] = useState(false);
    const x = useMotionValue(-100);
    const y = useMotionValue(-100);
    const sx = useSpring(x, { stiffness: 500, damping: 45, mass: 0.4 });
    const sy = useSpring(y, { stiffness: 500, damping: 45, mass: 0.4 });

    useEffect(() => {
        if (!window.matchMedia("(pointer: fine)").matches) return;
        setEnabled(true);
        const move = (e) => {
            x.set(e.clientX);
            y.set(e.clientY);
        };
        const over = (e) => {
            if (e.target.closest('[data-cursor="view"]')) setVariant("view");
            else if (e.target.closest('a, button, [data-cursor="link"]')) setVariant("link");
            else setVariant("default");
        };
        window.addEventListener("mousemove", move);
        window.addEventListener("mouseover", over);
        return () => {
            window.removeEventListener("mousemove", move);
            window.removeEventListener("mouseover", over);
        };
    }, [x, y]);

    if (!enabled) return null;

    return (
        <motion.div
            data-testid="custom-cursor"
            className="pointer-events-none fixed left-0 top-0 z-[140]"
            style={{ x: sx, y: sy }}
            aria-hidden="true"
        >
            <motion.img
                src="/media/cursor-logo.png"
                alt=""
                draggable={false}
                className="absolute w-8 -translate-x-1/2 -translate-y-1/2 select-none"
                style={{ filter: "drop-shadow(0 0 8px rgba(8,8,10,0.9))" }}
                animate={variant}
                variants={{
                    default: { scale: 1, rotate: 0, opacity: 1 },
                    link: { scale: 1.5, rotate: -10, opacity: 1 },
                    view: { scale: 0.4, rotate: 0, opacity: 0 },
                }}
                transition={{ type: "spring", stiffness: 350, damping: 22 }}
            />
            <motion.div
                className="flex h-[92px] w-[92px] -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-[#E63946]"
                animate={variant}
                variants={{
                    default: { scale: 0, opacity: 0 },
                    link: { scale: 0, opacity: 0 },
                    view: { scale: 1, opacity: 1 },
                }}
                transition={{ type: "spring", stiffness: 320, damping: 24 }}
            >
                <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#F4F4F0]">Ansehen</span>
            </motion.div>
        </motion.div>
    );
}
